import React from 'react';
import { css } from 'aphrodite';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import styles from './styles';

export type FolderPickerPreviousFolderDeletedBannerProps = {
  currentMatterName: string;
  projectName: string;
};

const FolderPickerPreviousFolderDeletedBanner = ({
  currentMatterName,
  projectName,
}: FolderPickerPreviousFolderDeletedBannerProps) => {
  return (
    <div className={css(styles.infoBanner)}>
      <div className={css(styles.infoBannerContent)}>
        <InfoOutlinedIcon className={css(styles.infoBannerIcon)} />
        <div>
          <div className={css(styles.infoBannerText)}>
            Previous folder was deleted.
          </div>
          <div className={css(styles.infoBannerSubText)}>
            The following item(s) will be saved as a new file / folder within
            the <span>{currentMatterName}</span> folder
          </div>
          <div className={css(styles.infoBannerBulletList)}>
            <span className={css(styles.infoBannerBullet)}>•</span>
            <span>{projectName}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FolderPickerPreviousFolderDeletedBanner;
